import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';

export const heading1Command = ({ editor, range }) =>
  range
    ? editor.chain().focus().deleteRange(range).toggleHeading({ level: 1 }).run()
    : editor.chain().focus().toggleHeading({ level: 1 }).run();

const Heading1 = ({ editor, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${indicateActive && editor.isActive('heading', { level: 1 }) ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<div className="text-gray-800 text-xs font-weight-500">H1</div>}
      onClick={isExtension ? () => {} : () => heading1Command({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="HEADING_1" defaultMessage="Heading 1" />
        </div>
      )}
    </Button>
  );
};

export default Heading1;
